// ISO 3166-1 alpha-2 codes with international dial codes.
// Country names are never hardcoded here — they are localized at render time
// with the browser's own Intl.DisplayNames for the active site language.
export const COUNTRIES = [
  { code: "AE", dial: "+971" }, { code: "AR", dial: "+54" }, { code: "AT", dial: "+43" },
  { code: "AU", dial: "+61" }, { code: "BA", dial: "+387" }, { code: "BE", dial: "+32" },
  { code: "BG", dial: "+359" }, { code: "BH", dial: "+973" }, { code: "BR", dial: "+55" },
  { code: "CA", dial: "+1" }, { code: "CH", dial: "+41" }, { code: "CL", dial: "+56" },
  { code: "CN", dial: "+86" }, { code: "CO", dial: "+57" }, { code: "CR", dial: "+506" },
  { code: "CY", dial: "+357" }, { code: "CZ", dial: "+420" }, { code: "DE", dial: "+49" },
  { code: "DK", dial: "+45" }, { code: "DO", dial: "+1" }, { code: "DZ", dial: "+213" },
  { code: "EC", dial: "+593" }, { code: "EE", dial: "+372" }, { code: "EG", dial: "+20" },
  { code: "ES", dial: "+34" }, { code: "FI", dial: "+358" }, { code: "FR", dial: "+33" },
  { code: "GB", dial: "+44" }, { code: "GR", dial: "+30" }, { code: "GT", dial: "+502" },
  { code: "HK", dial: "+852" }, { code: "HR", dial: "+385" }, { code: "HU", dial: "+36" },
  { code: "ID", dial: "+62" }, { code: "IE", dial: "+353" }, { code: "IL", dial: "+972" },
  { code: "IN", dial: "+91" }, { code: "IQ", dial: "+964" }, { code: "IR", dial: "+98" },
  { code: "IS", dial: "+354" }, { code: "IT", dial: "+39" }, { code: "JO", dial: "+962" },
  { code: "JP", dial: "+81" }, { code: "KE", dial: "+254" }, { code: "KW", dial: "+965" },
  { code: "KZ", dial: "+7" }, { code: "LB", dial: "+961" }, { code: "LI", dial: "+423" },
  { code: "LT", dial: "+370" }, { code: "LU", dial: "+352" }, { code: "LV", dial: "+371" },
  { code: "LY", dial: "+218" }, { code: "MA", dial: "+212" }, { code: "MC", dial: "+377" },
  { code: "MD", dial: "+373" }, { code: "ME", dial: "+382" }, { code: "MK", dial: "+389" },
  { code: "MT", dial: "+356" }, { code: "MX", dial: "+52" }, { code: "MY", dial: "+60" },
  { code: "NG", dial: "+234" }, { code: "NL", dial: "+31" }, { code: "NO", dial: "+47" },
  { code: "NZ", dial: "+64" }, { code: "OM", dial: "+968" }, { code: "PA", dial: "+507" },
  { code: "PE", dial: "+51" }, { code: "PH", dial: "+63" }, { code: "PK", dial: "+92" },
  { code: "PL", dial: "+48" }, { code: "PT", dial: "+351" }, { code: "QA", dial: "+974" },
  { code: "RO", dial: "+40" }, { code: "RS", dial: "+381" }, { code: "RU", dial: "+7" },
  { code: "SA", dial: "+966" }, { code: "SE", dial: "+46" }, { code: "SG", dial: "+65" },
  { code: "SI", dial: "+386" }, { code: "SK", dial: "+421" }, { code: "SM", dial: "+378" },
  { code: "KR", dial: "+82" }, { code: "SD", dial: "+249" }, { code: "SV", dial: "+503" },
  { code: "TH", dial: "+66" }, { code: "TN", dial: "+216" }, { code: "TR", dial: "+90" },
  { code: "TW", dial: "+886" }, { code: "UA", dial: "+380" }, { code: "US", dial: "+1" },
  { code: "UY", dial: "+598" }, { code: "VA", dial: "+39" }, { code: "VE", dial: "+58" },
  { code: "VN", dial: "+84" }, { code: "ZA", dial: "+27" },
];

const LOCALES = { EN: "en", ES: "es", DE: "de", AR: "ar" };

export function countryName(code, lang) {
  try {
    return new Intl.DisplayNames([LOCALES[lang] || "en"], { type: "region" }).of(code) || code;
  } catch {
    return code;
  }
}

export function sortedCountries(lang) {
  return COUNTRIES.map((c) => ({ ...c, name: countryName(c.code, lang) }))
    .sort((a, b) => a.name.localeCompare(b.name, LOCALES[lang] || "en"));
}
